import styled from "styled-components";
import { theme } from "styled-tools";

export const InputTextarea = styled.textarea`
  cursor: pointer;
  border-radius: 12px;
  font-size: 18px;
  border-width: 1px;
  border-style: solid;
  color: ${theme("Dark_Silver")};
  border-color: ${theme("Silver_Sand")};
  background: ${theme("White")};
  background-position: 3% 50%;
  margin-top: 8px;
  box-sizing: border-box;
  height: 135px;
  padding: 15px;
  width: 100%;
  resize: vertical;
`;

export const TextareaStyled = styled.div`
  width: 100%;
  max-width: 650px;
  padding: 24px 0;
  box-sizing: border-box;
`;

export const TextContainer = styled.div`
  font-family: "Montserrat";
  margin-top: 5px;
  width: 100%;
  color: ${theme("Dark_Silver")};
  display: flex;
  flex-direction: row;
  align-content: center;
  &.hidden {
    display: none;
  }
`;

export const Text = styled.span`
  font-size: 18px;
  font-weight: 700;
  margin-left: 5px;
  text-align: left;
`;

export const ErrorText = styled.div`
  font-family: "Montserrat";
  margin-top: 5px;
  width: 100%;
  color: ${theme("Dark_Silver")};
  display: flex;
  flex-direction: row;
  align-content: center;
  &.hidden {
    display: none;
  }
`;

export const Span = styled.span`
  margin-left: 4px;
  display: flex;
  flex-direction: row;
  position: relative;
  font-size: 16px;
  color: ${theme("Madder_Lake")};
  width: 70%;
  height: 15px;
  text-align: left;
`;
